module.exports = __webpack_public_path__ + "img/role_5.7a6439e6.png";